function closeAllPrimaryDropdowns() {
    document.querySelectorAll('.nav--primary > .nav-item--parent').forEach((menuItem) => {
        const trigger = menuItem.querySelector('.nav-link--tab');
        const dropdown = menuItem.querySelector('.menu__dropdown');

        if (trigger && dropdown) {
            dropdown.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
        }
    });
}

function closeAllMetaDropdowns() {
    document.querySelectorAll('.meta__nav').forEach((metaNav) => {
        const trigger = metaNav.querySelector(':scope > .nav-link');
        const dropdown = metaNav.querySelector('.dropdown--meta');

        if (trigger && dropdown) {
            dropdown.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
        }
    });
}

function closeLanguageSelector() {
    const ls = document.querySelector('.language-selector');

    if (!ls) return;

    const wrapper = ls.querySelector('.language-selector__wrapper');

    if (wrapper) wrapper.classList.remove('language-selector__wrapper--visible');

    ls.classList.remove('language-selector--open');
    ls.setAttribute('aria-expanded', 'false');

    const overlay = ls.querySelector('.nav-overlay');

    if (overlay) overlay.classList.remove('is-active');
}

function closeExtranetDropdown() {
    const container = document.querySelector('.meta__nav--extranet');

    if (!container) return;

    const dropdown = container.querySelector('.nav__dropdown--meta');

    if (dropdown) dropdown.classList.remove('is-open');

    container.querySelectorAll('[data-toggle-dropdown-meta-extranet]').forEach((el) => {
        el.classList.remove('is-active');
    });

    const trigger = container.querySelector(':scope > a[data-toggle-dropdown-meta-extranet]');

    if (trigger) trigger.setAttribute('aria-expanded', 'false');
}

function closeAllDropdowns() {
    closeAllPrimaryDropdowns();
    closeAllMetaDropdowns();
    closeLanguageSelector();
    closeExtranetDropdown();
}

// Primary menu

document.addEventListener('keydown', (e) => {
    if (e.code !== 'Space') return;

    const focused = document.activeElement;

    if (!focused || !focused.classList.contains('nav-link--tab')) return;

    const menuItem = focused.closest('.menu__item');

    if (!menuItem) return;

    const dropdown = menuItem.querySelector('.menu__dropdown');

    if (!dropdown) return;

    e.preventDefault();
    e.stopPropagation();

    const isOpen = dropdown.classList.contains('is-open');

    closeAllDropdowns();

    if (!isOpen) {
        dropdown.classList.add('is-open');
        focused.setAttribute('aria-expanded', 'true');

        const firstLink = dropdown.querySelector('.dropdown__body a, .dropdown__body button');

        if (firstLink) {
            firstLink.focus();
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const focused = document.activeElement;

    if (!focused) return;

    const dropdown = focused.closest('.menu__dropdown');

    if (!dropdown) return;

    const menuItem = dropdown.closest('.menu__item');

    if (!menuItem) return;

    const trigger = menuItem.querySelector('.nav-link--tab');

    if (!trigger) return;

    dropdown.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus();
});

document.addEventListener('focusout', (e) => {
    const menuItem = e.target.closest('.menu__item');

    if (!menuItem) return;

    const dropdown = menuItem.querySelector('.menu__dropdown');

    if (!dropdown || !dropdown.classList.contains('is-open')) return;

    requestAnimationFrame(() => {
        if (!menuItem.contains(document.activeElement)) {
            const trigger = menuItem.querySelector('.nav-link--tab');

            dropdown.classList.remove('is-open');

            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
            }
        }
    });
});

// Meta menu

document.addEventListener('keydown', (e) => {
    if (e.code !== 'Space' && e.key !== 'Enter') return;

    const focused = document.activeElement;

    if (!focused) return;

    const metaNav = focused.closest('.meta__nav');

    if (!metaNav || !focused.matches('.meta__nav > .nav-link')) return;

    const dropdown = metaNav.querySelector('.dropdown--meta');

    if (!dropdown) return;

    e.preventDefault();
    e.stopPropagation();

    const isOpen = dropdown.classList.contains('is-open');

    closeAllDropdowns();

    if (!isOpen) {
        dropdown.classList.add('is-open');
        focused.setAttribute('aria-expanded', 'true');

        const firstLink = dropdown.querySelector('.dropdown__body a, .dropdown__body .nav-link');

        if (firstLink) {
            firstLink.focus();
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const focused = document.activeElement;

    if (!focused) return;

    const dropdown = focused.closest('.dropdown--meta');

    if (!dropdown) return;

    const metaNav = dropdown.closest('.meta__nav');

    if (!metaNav) return;

    const trigger = metaNav.querySelector(':scope > .nav-link');

    if (!trigger) return;

    dropdown.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus();
});

document.addEventListener('focusout', (e) => {
    const metaNav = e.target.closest('.meta__nav');

    if (!metaNav) return;

    const dropdown = metaNav.querySelector('.dropdown--meta');

    if (!dropdown || !dropdown.classList.contains('is-open')) return;

    if (!e.relatedTarget) return;

    if (e.relatedTarget.closest('.meta__nav')) return;

    if (!metaNav.contains(e.relatedTarget)) {
        const trigger = metaNav.querySelector(':scope > .nav-link');

        dropdown.classList.remove('is-open');

        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
        }
    }
});

// Language selector

document.addEventListener('keydown', (e) => {
    if (e.code !== 'Space' && e.key !== 'Enter') return;

    const focused = document.activeElement;

    if (!focused) return;

    // Language selector trigger
    if (focused.classList.contains('language-selector')) {
        e.preventDefault();

        const wrapper = focused.querySelector('.language-selector__wrapper');
        const wasOpen = wrapper && wrapper.classList.contains('language-selector__wrapper--visible');

        closeAllDropdowns();

        if (!wasOpen) {
            wrapper.classList.add('language-selector__wrapper--visible');
            focused.classList.add('language-selector--open');
            focused.setAttribute('aria-expanded', 'true');

            const overlay = focused.querySelector('.nav-overlay');

            if (overlay) overlay.classList.add('is-active');

            const firstInteractive = wrapper.querySelector('a, [tabindex="0"]');

            if (firstInteractive) {
                firstInteractive.focus();
            }
        }

        return;
    }

    // Interactive elements inside language selector
    const ls = focused.closest('.language-selector');

    if (!ls) return;

    if (focused.classList.contains('language-selector__to-countries')) {
        e.preventDefault();

        ls.querySelectorAll('.language-selector__current').forEach((el) => {
            el.classList.add('language-selector__content--hidden');
        });
        ls.querySelectorAll('.language-selector__countries').forEach((el) => {
            el.classList.remove('language-selector__content--hidden');
        });

        const backButton = ls.querySelector('.language-selector__item--back');

        if (backButton) backButton.focus();

        return;
    }

    if (focused.classList.contains('language-selector__item--back')) {
        e.preventDefault();

        ls.querySelectorAll('.language-selector__current').forEach((el) => {
            el.classList.remove('language-selector__content--hidden');
        });
        ls.querySelectorAll('.language-selector__countries').forEach((el) => {
            el.classList.add('language-selector__content--hidden');
        });

        const toCountries = ls.querySelector('.language-selector__to-countries');

        if (toCountries) toCountries.focus();

        return;
    }

    if (focused.classList.contains('language-selector__item--down')) {
        e.preventDefault();
        focused.classList.toggle('language-selector__item--down--open');

        const isExpanded = focused.classList.contains('language-selector__item--down--open');
        focused.setAttribute('aria-expanded', String(isExpanded));

        const sibling = focused.nextElementSibling;

        if (sibling) sibling.classList.toggle('language-selector__items--open');
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const focused = document.activeElement;

    if (!focused) return;

    const languageSelector = focused.closest('.language-selector');

    if (!languageSelector) return;

    const wrapper = languageSelector.querySelector('.language-selector__wrapper');

    if (!wrapper || !wrapper.classList.contains('language-selector__wrapper--visible')) return;

    closeLanguageSelector();
    languageSelector.focus();
});

// Extranet dropdown (Mijn omgeving)

document.addEventListener('keydown', (e) => {
    if (e.code !== 'Space' && e.key !== 'Enter') return;

    const focused = document.activeElement;

    if (!focused) return;

    if (!focused.hasAttribute('data-toggle-dropdown-meta-extranet') ||
        !focused.closest('.meta__nav--extranet')) return;

    e.preventDefault();
    e.stopPropagation();

    const container = focused.closest('.meta__nav--extranet');
    const dropdown = container.querySelector('.nav__dropdown--meta');

    if (!dropdown) return;

    const isOpen = dropdown.classList.contains('is-open');

    closeAllDropdowns();

    if (!isOpen) {
        focused.click();
        focused.setAttribute('aria-expanded', 'true');

        const firstLink = dropdown.querySelector('.dropdown__body a, .dropdown__body .nav-link');

        if (firstLink) {
            firstLink.focus();
        }
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const focused = document.activeElement;

    if (!focused) return;

    const dropdown = focused.closest('.nav__dropdown--meta');

    if (!dropdown) return;

    const container = dropdown.closest('.meta__nav--extranet');

    if (!container) return;

    const trigger = container.querySelector(':scope > a[data-toggle-dropdown-meta-extranet]');

    if (!trigger) return;

    dropdown.classList.remove('is-open');
    container.querySelectorAll('[data-toggle-dropdown-meta-extranet]').forEach((el) => {
        el.classList.remove('is-active');
    });
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus();
});

document.addEventListener('focusout', (e) => {
    const container = e.target.closest('.meta__nav--extranet');

    if (!container) return;

    const dropdown = container.querySelector('.nav__dropdown--meta');

    if (!dropdown || !dropdown.classList.contains('is-open')) return;

    requestAnimationFrame(() => {
        if (!container.contains(document.activeElement)) {
            closeExtranetDropdown();
        }
    });
});
